/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiPerson } from './InternalApiPerson';
import {
    InternalApiPersonFromJSON,
    InternalApiPersonFromJSONTyped,
    InternalApiPersonToJSON,
    InternalApiPersonToJSONTyped,
} from './InternalApiPerson';
import type { InternalApiAssignmentUser } from './InternalApiAssignmentUser';
import {
    InternalApiAssignmentUserFromJSON,
    InternalApiAssignmentUserFromJSONTyped,
    InternalApiAssignmentUserToJSON,
    InternalApiAssignmentUserToJSONTyped,
} from './InternalApiAssignmentUser';
import type { InternalApiNote } from './InternalApiNote';
import {
    InternalApiNoteFromJSON,
    InternalApiNoteFromJSONTyped,
    InternalApiNoteToJSON,
    InternalApiNoteToJSONTyped,
} from './InternalApiNote';
import type { InternalApiManualAlertRationale } from './InternalApiManualAlertRationale';
import {
    InternalApiManualAlertRationaleFromJSON,
    InternalApiManualAlertRationaleFromJSONTyped,
    InternalApiManualAlertRationaleToJSON,
    InternalApiManualAlertRationaleToJSONTyped,
} from './InternalApiManualAlertRationale';
import type { InternalApiTransaction } from './InternalApiTransaction';
import {
    InternalApiTransactionFromJSON,
    InternalApiTransactionFromJSONTyped,
    InternalApiTransactionToJSON,
    InternalApiTransactionToJSONTyped,
} from './InternalApiTransaction';

/**
 * 
 * @export
 * @interface InternalApiManualAlert
 */
export interface InternalApiManualAlert {
    /**
     * 
     * @type {number}
     * @memberof InternalApiManualAlert
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiManualAlert
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiManualAlert
     */
    statusId: number;
    /**
     * 
     * @type {InternalApiPerson}
     * @memberof InternalApiManualAlert
     */
    person: InternalApiPerson;
    /**
     * 
     * @type {InternalApiTransaction}
     * @memberof InternalApiManualAlert
     */
    transaction?: InternalApiTransaction;
    /**
     * 
     * @type {InternalApiManualAlertRationale}
     * @memberof InternalApiManualAlert
     */
    rationale: InternalApiManualAlertRationale;
    /**
     * 
     * @type {string}
     * @memberof InternalApiManualAlert
     */
    rationaleComment?: string;
    /**
     * 
     * @type {InternalApiAssignmentUser}
     * @memberof InternalApiManualAlert
     */
    assignee?: InternalApiAssignmentUser;
    /**
     * Name of the user who created the alert
     * @type {string}
     * @memberof InternalApiManualAlert
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiManualAlert
     */
    createdTime: Date;
    /**
     * 
     * @type {Array<InternalApiNote>}
     * @memberof InternalApiManualAlert
     */
    notes: Array<InternalApiNote>;
}



/**
 * Check if a given object implements the InternalApiManualAlert interface.
 */
export function instanceOfInternalApiManualAlert(value: object): value is InternalApiManualAlert {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('statusId' in value) || value['statusId'] === undefined) return false;
    if (!('person' in value) || value['person'] === undefined) return false;
    if (!('rationale' in value) || value['rationale'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    return true;
}

export function InternalApiManualAlertFromJSON(json: any): InternalApiManualAlert {
    return InternalApiManualAlertFromJSONTyped(json, false);
}

export function InternalApiManualAlertFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiManualAlert {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': json['status'],
        'statusId': json['statusId'],
        'person': InternalApiPersonFromJSON(json['person']),
        'transaction': json['transaction'] == null ? undefined : InternalApiTransactionFromJSON(json['transaction']),
        'rationale': InternalApiManualAlertRationaleFromJSON(json['rationale']),
        'rationaleComment': json['rationaleComment'] == null ? undefined : json['rationaleComment'],
        'assignee': json['assignee'] == null ? undefined : InternalApiAssignmentUserFromJSON(json['assignee']),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdTime': (new Date(json['createdTime'])),
        'notes': ((json['notes'] as Array<any>).map(InternalApiNoteFromJSON)),
    };
}

export function InternalApiManualAlertToJSON(json: any): InternalApiManualAlert {
    return InternalApiManualAlertToJSONTyped(json, false);
}

export function InternalApiManualAlertToJSONTyped(value?: InternalApiManualAlert | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'statusId': value['statusId'],
        'person': InternalApiPersonToJSON(value['person']),
        'transaction': InternalApiTransactionToJSON(value['transaction']),
        'rationale': InternalApiManualAlertRationaleToJSON(value['rationale']),
        'rationaleComment': value['rationaleComment'],
        'assignee': InternalApiAssignmentUserToJSON(value['assignee']),
        'createdBy': value['createdBy'],
        'createdTime': value['createdTime'].toISOString(),
        'notes': ((value['notes'] as Array<any>).map(InternalApiNoteToJSON)),
    };
}

